import type { InitialProductsState } from 'ecosystem'
import { useCustomerScopedRequest } from '../../common/hooks/useCustomerScope'

interface UseInitialProductReqProps {
  endpointPath: string
  id: string
  type: 'category' | 'brand' | 'search' | 'tag'
  queryParams: any
}

const useInitialProductsRequest = ({
  endpointPath,
  id,
  type,
  queryParams
}: UseInitialProductReqProps) => {
  const qp = new URLSearchParams(queryParams).toString()

  // Prices and buyability come from the session on the server, so this response
  // belongs to the current customer — not to the url alone.
  return useCustomerScopedRequest<InitialProductsState>(
    qp ? `${endpointPath}?id=${id}&type=${type}&${qp}` : null,
    'state'
  )
}

export default useInitialProductsRequest
